import { NextPage } from 'next'
import Head from 'next/head'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useSWRInfinite from 'swr/infinite'
import { ZENDESK_API_URL, Article, Articles, axios } from '~/apis'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { ASSET_PREFIX } from '~/constants/env'
import { LOCALES } from '~/locales'
import { parseArticle, useGA } from '~/hooks'
import { StyledBlog } from './styled'

const Blog: NextPage = () => {
  const { t, i18n } = useTranslation()
  const { trackElClick, trackClick } = useGA()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const lang = isZh ? 'zh-cn' : 'en-us'

  const { data, size, setSize } = useSWRInfinite(
    (index) =>
      `${ZENDESK_API_URL}/help_center/${lang}/articles?page=${
        index + 1
      }&sort_by=created_at`,
    (url): Promise<Articles> => axios.get(url),
  )
  const loadedPageCount = data?.length ?? 0
  const loadedLastPageData = (data && loadedPageCount > 0
    ? data[loadedPageCount - 1]
    : {}) as Articles
  const currentPage = loadedLastPageData?.page ?? 0
  const totalPageCount = loadedLastPageData?.page_count ?? 0

  const articles = data?.reduce(
    (acc, d) => [...acc, ...(d?.articles ?? []).map(parseArticle)],
    [],
  )

  return (
    <>
      <Head>
        <title>{t('meta_blog_title')}</title>
        <meta name="description" content={t('meta_blog_description')} />
        <meta name="keywords" content={t('meta_common_keywords')} />
      </Head>
      <StyledBlog>
        <Header />
        <div className="blog-page">
          <div className="blog-page">
            <section className="content">
              <h1>Blog</h1>
              <div
                className="articles"
                data-thumbnail={`${ASSET_PREFIX}/images/blog-article-cover.png`}
              >
                {articles?.map((article, index) => (
                  <a
                    key={article?.id}
                    className="article-card"
                    href={`/blog/${article?.id}`}
                    data-trackid="webtl_blog_detail"
                    data-trackdata={JSON.stringify({
                      title: article?.title,
                      url: `/blog/${article?.id}`,
                      index,
                    })}
                    onClick={trackElClick}
                  >
                    <img src={article?.thumbnail} alt={article?.title} />
                    <div className="card-content">
                      <p className="title">{article?.title}</p>
                      <div className="article-body"> {article?.digest}</div>
                      <span className="updated-at">{article?.created_at}</span>
                    </div>
                  </a>
                ))}
              </div>
              {currentPage < totalPageCount && (
                <div className="load-more">
                  <div
                    className="button"
                    onClick={() => {
                      trackClick('webtl_blog_loadmore')
                      setSize(size + 1)
                    }}
                  >
                    <p>{t('load_more')}</p>
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>
        <Footer />
      </StyledBlog>
    </>
  )
}

export default Blog
